var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-fancy-progress"},[_c('div',{staticClass:"c-fancy-progress__bar",class:_vm.checkColor,style:({
      width:
        +_vm.convertPercent(_vm.percent) > 100 ? '100' : _vm.convertPercent(_vm.percent) + '%'
    })},[_c('div',{staticClass:"c-fancy-progress__bar-shadow"})]),_c('div',{staticClass:"c-fancy-progress__bar-text"},[_vm._t("bar-text")],2),_c('div',{staticClass:"c-fancy-progress__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }